var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap -mx-1"},_vm._l((7),function(day){return _c('div',{key:day,staticClass:"p-1"},[_c('vue-checkbox',{staticClass:"no-bullet",attrs:{"disabled":_vm.disabled,"label":day},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._v(_vm._s(_vm.getName(day)))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }